import React from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'

import { usePlaceImages } from 'tripPlanner/hooks/Google/usePlaceImages'

const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
`

type Props = {
  placeId: string
  title: string
  tripId: string
  tripItemId: string
  placeholder?: React.ReactNode
}
function GoogleCardImage({
  placeId,
  tripId,
  tripItemId,
  title,
  placeholder,
}: Props) {
  const [imageRef, imageInView] = useInView({
    triggerOnce: true, // Load it once and keep it loaded
    rootMargin: '200px', // Trigger 500px before the component is reached
  })
  const { data: images, isLoading } = usePlaceImages(
    {
      placeId,
      maxWidthPx: 640,
      tripId,
      tripItemId,
    },
    { enabled: imageInView },
  )

  if (isLoading) return <div ref={imageRef}></div>
  const photoUrl = images?.[0]?.url
  if (!photoUrl) return <>{placeholder}</>
  return <Image ref={imageRef} src={photoUrl} alt={title} />
}
export default GoogleCardImage
